import {
    faAddressCard,
    faBicycle,
    faDolly,
    faExchange,
    faFileInvoiceDollar,
    faGraduationCap,
    faReceipt,
    faThLarge,
    faTshirt,
    faPlusLarge,
    faWrench,
} from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { AppPageRoutes } from 'src/services/api/models';
import { LetterLogo } from '../components/Logo';
import CONFIG from './config';
import { AppBrands } from './constants';

export interface GroupRoutes {
    name: string;
    routes: ListRoutes[];
}

export interface ListRoutes {
    icon: any;
    text: string;
    route: AppPageRoutes | string;
    target?: string;
    testId: string;
}

export const getMenuListRoutes = ({ useNewReturnRequest }: { useNewReturnRequest?: boolean }) => {
    const brandName = CONFIG.APP_BRAND;
    const isQwic = brandName === AppBrands.QWIC;

    const CommonRoutes = {
        dashboard: [
            {
                icon: <LetterLogo width={24} style={{ display: 'flex' }} />,
                text: 'menu.dashboard',
                route: AppPageRoutes.DASHBOARD,
                testId: 'menu-dashboard',
            },
        ],
        ordersProducts: [
            {
                icon: faBicycle,
                text: 'menu.products',
                route: AppPageRoutes.PRODUCTS,
                testId: 'menu-products',
            },
            {
                icon: faWrench,
                text: 'menu.spare_parts',
                route: AppPageRoutes.SPARE_PARTS,
                testId: 'menu-spare-parts',
            },
        ],
        orders: [
            {
                icon: faReceipt,
                text: 'menu.orders',
                route: AppPageRoutes.ORDERS,
                testId: 'menu-orders',
            },
            {
                icon: faFileInvoiceDollar,
                text: 'menu.invoices',
                route: AppPageRoutes.INVOICES,
                testId: 'menu-invoices',
            },
        ],
        information: [
            {
                icon: faGraduationCap,
                text: 'menu.knowledgeInfo',
                route: AppPageRoutes.KNOWLEDGE_INFO,
                testId: 'menu-knowledge-info',
            },
            {
                icon: faAddressCard,
                text: 'menu.contact',
                route: AppPageRoutes.CONTACT,
                testId: 'menu-contact',
            },
        ],
    };

    const QwicRoutes = {
        dashboard: [
            {
                icon: faThLarge,
                text: 'menu.bikeDashboard',
                route: AppPageRoutes.BIKE_DASHBOARD,
                testId: 'menu-bikeDashboard',
            },
        ],
        ordersProducts: [
            {
                icon: faTshirt,
                text: 'menu.marketingMaterials',
                route: AppPageRoutes.MARKETING_MATERIALS,
                testId: 'menu-marketing-materials',
            },
        ],
        returns: [
            {
                icon: faPlusLarge,
                text: 'menu.newReturn',
                route: AppPageRoutes.NEW_RETURN_REQUEST,
                testId: 'menu-new-return-request',
            },
            {
                icon: faExchange,
                text: 'menu.viewReturns',
                route: AppPageRoutes.RETURN_REQUESTS,
                testId: 'menu-return-requests',
            },
            ...(useNewReturnRequest
                ? [
                      {
                          icon: faDolly,
                          text: 'menu.shipReturns',
                          route: AppPageRoutes.SHIP_RETURN_ITEMS,
                          testId: 'menu-ship-return-items',
                      },
                  ]
                : []),
        ],
    };

    const groupedListOfRoutes: GroupRoutes[] = [
        {
            name: 'dashboard',
            routes: [...CommonRoutes.dashboard, ...(isQwic ? QwicRoutes.dashboard : [])],
        },
        {
            name: 'menu.group.orders',
            routes: [
                ...CommonRoutes.ordersProducts,
                ...(isQwic ? QwicRoutes.ordersProducts : []),
                ...CommonRoutes.orders,
            ],
        },
        ...(isQwic
            ? [
                  {
                      name: 'menu.group.returns',
                      routes: QwicRoutes.returns,
                  },
              ]
            : []),
        {
            name: 'menu.group.information',
            routes: CommonRoutes.information,
        },
    ];

    return groupedListOfRoutes;
};
